import { Component } from '@angular/core';

@Component({
    selector: 'sura-inicio',
    template: `
    <div class="text-center mt-5" alt="logo_sura">
      <img src="../../../../assets/img/tigre-banner.png" alt="Tigre banner">
    </div>
  `,
    standalone: false
})
export class InicioComponent {

}